import moment from "moment";
import { Button, message } from "antd";
import { ExportToCsv } from "export-to-csv";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  GetReportPeriodData,
  GetReportPeriodDataByOperator,
  GetGantt,
  ConvertTimespanToDateBasedOnTimezone,
} from "../../../../services/common/cnc_apis";
import Urls, { postRequest } from "../../../../services/common/urls";
import lang from "../../../../services/lang";
import "./ExportCSVButton.css";

function ExportCSVButton(props) {
  const { langIndex } = useSelector((x) => x.app);
  const {
    customer_id,
    fromReportDate,
    toReportDate,
    selectedMachine,
    selectedOperator,
    customerInfo,
    machineInfo,
    selectedEmails,
  } = props;
  const [isGeneratingCSV, setIsGeneratingCSV] = useState(false);
  const [isExportingGantt, setIsExportingGantt] = useState(false);
  const [isExportingTimeTotals, setIsExportingTimeTotals] = useState(false);

  const onSendAsEmail = (csvData) => {
    if (csvData.length == 0) return;
    var mailData = [];
    mailData.push(Object.keys(csvData[0]));
    csvData.forEach((item) => {
      mailData.push(Object.values(item));
    });

    var url = Urls.CSV_SENDER;
    var param = {
      csvData: mailData,
      emailList: selectedEmails,
    };
    postRequest(url, param, (res) => {});
  };

  const onGenerateCSV = () => {
    setIsGeneratingCSV(true);
    if (selectedMachine != null && selectedMachine.length > 0) {
      GetReportPeriodData(
        customer_id,
        selectedMachine,
        customerInfo["timezone"],
        fromReportDate,
        toReportDate,
        (res) => {
          if (res.status === false) {
            message.error(lang(langIndex, "msg_something_wrong"));
            setIsGeneratingCSV(false);
          } else {
            const oee_o = res.data["oee_o"] || [];
            if (oee_o.length === 0) {
              message.error(lang(langIndex, "msg_no_data_print"));
              setIsGeneratingCSV(false);
              return;
            }
            exportToCSV({ ...res.data });
          }
        }
      );
    } else {
      GetReportPeriodDataByOperator(
        customer_id,
        selectedOperator,
        customerInfo["timezone"],
        fromReportDate,
        toReportDate,
        (res) => {
          setIsGeneratingCSV(false);
          if (res == null) {
            message.error("No Data");
            return;
          }
          if (res.status === false) {
            message.error("No Data");
          } else {
            if (res.data["oee_o"].length === 0) {
              message.error(lang(langIndex, "msg_no_data_print"));
              return;
            }
            exportToCSV({ ...res.data });
          }
        }
      );
    }
  };

  const exportToCSV = (data) => {
    var no = 1;
    const hstData = data.oee_o;
    const appSettings = data.appSettings;
    var key1 =
      appSettings.length > 0 && appSettings[0].downtime_reason1 !== ""
        ? appSettings[0].downtime_reason1
        : "Downtime Reason1";

    var key2 =
      appSettings.length > 0 && appSettings[0].downtime_reason2 !== ""
        ? appSettings[0].downtime_reason2
        : "Downtime Reason2";
    var key3 =
      appSettings.length > 0 && appSettings[0].downtime_reason3 !== ""
        ? appSettings[0].downtime_reason3
        : "Downtime Reason3";
    var key4 =
      appSettings.length > 0 && appSettings[0].downtime_reason4 !== ""
        ? appSettings[0].downtime_reason4
        : "Downtime Reason4";
    var key5 =
      appSettings.length > 0 && appSettings[0].downtime_reason5 !== ""
        ? appSettings[0].downtime_reason5
        : "Downtime Reason5";
    var key6 =
      appSettings.length > 0 && appSettings[0].downtime_reason6 !== ""
        ? appSettings[0].downtime_reason6
        : "Downtime Reason6";
    var key7 =
      appSettings.length > 0 && appSettings[0].downtime_reason7 !== ""
        ? appSettings[0].downtime_reason7
        : "Downtime Reason7";
    var key8 =
      appSettings.length > 0 && appSettings[0].downtime_reason8 !== ""
        ? appSettings[0].downtime_reason8
        : "Downtime Reason8";

    var csvData = [];
    for (var i = 0; i < hstData.length; i++) {
      var hsv = hstData[i];
      // var item = {
      //   no: no,
      //   date: i > 0 && hsv.date === hstData[i - 1].date ? "" : hsv.date,
      //   machine:
      //     i > 0 && hsv.machine_id === hstData[i - 1].machine_id
      //       ? ""
      //       : hsv.machine_id,
      //   Operator: hsv.Operator,
      //   oee: `${hsv.oee / 100}`,
      //  // utilization: `${0}`,
      //   availability: `${hsv.availability / 100}`,
      //   quality: `${
      //     parseFloat(hsv.goodParts) + parseFloat(hsv.badParts) == 0
      //       ? 0
      //       : (
      //           parseFloat(hsv.goodParts) /
      //           (parseFloat(hsv.goodParts) + parseFloat(hsv.badParts))
      //         ).toFixed(2)
      //   }`,
      //   performance: `${hsv.performance / 100}`,
      //   goodParts: "",
      //   badParts: "",
      // };

      var item = {
        no: no,
        date: hsv.date,
        machine: hsv.machine_id,
        Operator: hsv.Operator,
        oee: `${hsv.oee / 100}`,
        // utilization: `${0}`,
        availability: `${hsv.availability / 100}`,
        quality: `${
          parseFloat(hsv.goodParts) + parseFloat(hsv.badParts) == 0
            ? 0
            : (
                parseFloat(hsv.goodParts) /
                (parseFloat(hsv.goodParts) + parseFloat(hsv.badParts))
              ).toFixed(2)
        }`,
        performance: `${hsv.performance / 100}`,
        goodParts: "",
        badParts: "",
      };

      item["Operator goodParts"] = hsv.goodParts;
      item["Operator badParts"] = hsv.badParts;

      if (customer_id == "sm_ks") item["Sq inches"] = hsv.sq_inches;
      item["Orders"] = "Total";

      item[key1] = Math.round((Number(hsv.r1t) / 60000 / 60) * 100) / 100;
      item[key2] = Math.round((Number(hsv.r2t) / 60000 / 60) * 100) / 100;
      item[key3] = Math.round((Number(hsv.r3t) / 60000 / 60) * 100) / 100;
      item[key4] = Math.round((Number(hsv.r4t) / 60000 / 60) * 100) / 100;
      item[key5] = Math.round((Number(hsv.r5t) / 60000 / 60) * 100) / 100;
      item[key6] = Math.round((Number(hsv.r6t) / 60000 / 60) * 100) / 100;
      item[key7] = Math.round((Number(hsv.r7t) / 60000 / 60) * 100) / 100;
      item[key8] = Math.round((Number(hsv.r8t) / 60000 / 60) * 100) / 100;

      item["Idle - Uncategorized"] =
        Math.round((Number(hsv.uncat) / 60000 / 60) * 100) / 100;
      item["Total Downtime"] =
        Math.round((Number(hsv.downtimes) / 60000 / 60) * 100) / 100;
      item["Total uptime"] =
        Math.round((Number(hsv.inCycle) / 60000 / 60) * 100) / 100;
      no++;
      csvData.push({ ...item });

      var subItems = data.oee.filter(
        (h) =>
          h.date === hsv.date &&
          h.machine_id === hsv.machine_id &&
          h.Operator === hsv.Operator
      );

      for (var j = 0; j < subItems.length; j++) {
        var sHsv = subItems[j];
        var subItem = {
          no: no,
          date: hsv.date,
          machine: hsv.machine_id,
          Operator: hsv.Operator,
          oee: `${sHsv.oee / 100}`,
          //utilization: `${0}`,
          availability: `${sHsv.availability / 100}`,
          quality: `${sHsv.quality / 100}`,
          performance: `${sHsv.performance / 100}`,
          goodParts: sHsv.goodParts,
          badParts: sHsv.badParts,
        };
        subItem["Operator goodParts"] = "";
        subItem["Operator badParts"] = "";

        if (customer_id == "sm_ks") subItem["Sq inches"] = sHsv.sq_inches;
        subItem["Orders"] = sHsv.Orders;

        subItem[key1] = Math.round((Number(sHsv.r1t) / 60000 / 60) * 100) / 100;
        subItem[key2] = Math.round((Number(sHsv.r2t) / 60000 / 60) * 100) / 100;
        subItem[key3] = Math.round((Number(sHsv.r3t) / 60000 / 60) * 100) / 100;
        subItem[key4] = Math.round((Number(sHsv.r4t) / 60000 / 60) * 100) / 100;
        subItem[key5] = Math.round((Number(sHsv.r5t) / 60000 / 60) * 100) / 100;
        subItem[key6] = Math.round((Number(sHsv.r6t) / 60000 / 60) * 100) / 100;
        subItem[key7] = Math.round((Number(sHsv.r7t) / 60000 / 60) * 100) / 100;
        subItem[key8] = Math.round((Number(sHsv.r8t) / 60000 / 60) * 100) / 100;

        subItem["Idle - Uncategorized"] =
          Math.round((Number(sHsv.uncat) / 60000 / 60) * 100) / 100;

        subItem["Total Downtime"] =
          Math.round((Number(sHsv.downtimes) / 60000 / 60) * 100) / 100;
        subItem["Total uptime"] =
          Math.round((Number(sHsv.inCycle) / 60000 / 60) * 100) / 100;
        no++;
        csvData.push({ ...subItem });
      }
    }

    var title = "";
    for (var i = 0; i < selectedMachine.length; i++) {
      if (i === 0) {
        title = title + selectedMachine[i];
      } else {
        title = title + "_" + selectedMachine[i];
      }
    }

    const options = {
      filename: `${title} ${fromReportDate}-${toReportDate}`,
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      title: `${title} ${fromReportDate}-${toReportDate}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(csvData);
    onSendAsEmail(csvData);
    setIsGeneratingCSV(false);
  };

  const downloadCSV = (csvData, filename, title) => {
    if (!csvData || csvData.length === 0) return;
    const options = {
      filename,
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      title,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(csvData);
    onSendAsEmail(csvData);
  };

  const onGanttRecordsClick = () => {
    if (!customerInfo || customerInfo["timezone"] == null) {
      message.error(lang(langIndex, "msg_something_wrong"));
      return;
    }
    setIsExportingGantt(true);
    GetGantt(
      customer_id,
      fromReportDate,
      toReportDate,
      customerInfo["timezone"],
      selectedMachine && selectedMachine.length > 0 ? selectedMachine : null,
      selectedOperator && selectedOperator.length > 0 ? selectedOperator : null,
      (res) => {
      setIsExportingGantt(false);
      if (res == null || res.status === false) {
        message.error(lang(langIndex, "msg_no_data_print"));
        return;
      }
      let segments = Array.isArray(res.data) ? res.data : (res.data && res.data.gantt) ? res.data.gantt : res.data ? [].concat(res.data) : [];
      if (segments.length === 0) {
        message.error(lang(langIndex, "msg_no_data_print"));
        return;
      }
      const timezone = customerInfo["timezone"];
      const csvData = segments.map((s) => {
        const startDate = ConvertTimespanToDateBasedOnTimezone(s.start, timezone);
        const endDate = ConvertTimespanToDateBasedOnTimezone(s.end, timezone);
        const durationMin = Math.round(((Number(s.end) - Number(s.start)) / 60) * 100) / 100;
        return {
          Machine: s.machine_id || "",
          "Start (Local)": moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
          "End (Local)": moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
          Status: s.status || "",
          "Duration (min)": durationMin,
          Operator: s.Operator != null ? s.Operator : "",
          "Job ID": s.job_id != null ? s.job_id : "",
          Comment: s.comment != null ? s.comment : "",
        };
      });
      const title = `Gantt_Records_${fromReportDate}_${toReportDate}`;
      downloadCSV(csvData, title, title);
    }
    );
  };

  const onTimeTotalsClick = () => {
    if (!customerInfo || customerInfo["timezone"] == null) {
      message.error(lang(langIndex, "msg_something_wrong"));
      return;
    }
    setIsExportingTimeTotals(true);
    GetGantt(
      customer_id,
      fromReportDate,
      toReportDate,
      customerInfo["timezone"],
      selectedMachine && selectedMachine.length > 0 ? selectedMachine : null,
      selectedOperator && selectedOperator.length > 0 ? selectedOperator : null,
      (res) => {
      setIsExportingTimeTotals(false);
      if (res == null || res.status === false) {
        message.error(lang(langIndex, "msg_no_data_print"));
        return;
      }
      let segments = Array.isArray(res.data) ? res.data : (res.data && res.data.gantt) ? res.data.gantt : res.data ? [].concat(res.data) : [];
      if (segments.length === 0) {
        message.error(lang(langIndex, "msg_no_data_print"));
        return;
      }
      const timezone = customerInfo["timezone"];
      const tzSeconds = (timezone || 0) * 3600;
      const getFactoryDateKey = (unixSec) => {
        const dayCount = Math.floor((unixSec + tzSeconds) / 86400);
        const startOfDayUtc = dayCount * 86400 - tzSeconds;
        return moment.utc(startOfDayUtc * 1000).format("YYYY-MM-DD");
      };
      const getFactoryDayStartSec = (unixSec) => {
        const dayCount = Math.floor((unixSec + tzSeconds) / 86400);
        return dayCount * 86400 - tzSeconds;
      };
      const map = {};
      segments.forEach((s) => {
        const status = s.status != null ? s.status : "Uncategorized";
        const startSec = Number(s.start);
        const endSec = Number(s.end);
        const startDayStart = getFactoryDayStartSec(startSec);
        const endDayStart = getFactoryDayStartSec(endSec);
        if (startDayStart === endDayStart) {
          const dateKey = getFactoryDateKey(startSec);
          const durationMin = (endSec - startSec) / 60;
          const key = `${dateKey}|${status}`;
          if (!map[key]) map[key] = { date: dateKey, category: status, minutes: 0 };
          map[key].minutes += durationMin;
        } else {
          let dayStartSec = startDayStart;
          while (dayStartSec < endSec) {
            const dayEndSec = dayStartSec + 86400;
            const dateKey = getFactoryDateKey(dayStartSec);
            const clipStart = Math.max(startSec, dayStartSec);
            const clipEnd = Math.min(endSec, dayEndSec);
            const durationMin = (clipEnd - clipStart) / 60;
            if (durationMin > 0) {
              const key = `${dateKey}|${status}`;
              if (!map[key]) map[key] = { date: dateKey, category: status, minutes: 0 };
              map[key].minutes += durationMin;
            }
            dayStartSec = dayEndSec;
          }
        }
      });
      const csvData = Object.values(map)
        .sort((a, b) => a.date.localeCompare(b.date) || a.category.localeCompare(b.category))
        .map((r) => ({
          Date: r.date,
          Category: r.category,
          "Minutes": Math.round(r.minutes * 100) / 100,
        }));
      const title = `Time_Totals_${fromReportDate}_${toReportDate}`;
      downloadCSV(csvData, title, title);
    }
    );
  };

  const canExport =
    (selectedMachine != null && selectedMachine.length > 0) ||
    (selectedOperator != null && selectedOperator.length > 0);

  return (
    <div className="export-csv-buttons">
      <Button
        type="primary"
        disabled={!canExport}
        loading={isGeneratingCSV}
        onClick={onGenerateCSV}
      >
        {lang(langIndex, "report_daily_productivity_report")}
      </Button>
      <Button
        type="primary"
        disabled={!canExport}
        loading={isExportingGantt}
        onClick={onGanttRecordsClick}
        style={{ marginLeft: 8 }}
      >
        {lang(langIndex, "report_gantt_records")}
      </Button>
      <Button
        type="primary"
        disabled={!canExport}
        loading={isExportingTimeTotals}
        onClick={onTimeTotalsClick}
        style={{ marginLeft: 8 }}
      >
        {lang(langIndex, "report_time_totals")}
      </Button>
    </div>
  );
}

export default ExportCSVButton;
